<template>
    <v-sheet>
        <h5 class="page-text--lg mb-8 mb-lg-16 line-height-15">기업회원 정보</h5>
        <v-divider class="primary border-2" />
        <v-data-table
            v-bind="{
                headers,

                items,
                itemKey: '_id',
                itemsPerPage: -1,

                loading,
            }"
            hide-default-footer
            disable-filtering
            disable-sort
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>

            <template #[`item.info.name`]="{ item, value }">
                <v-layout column align-center>
                    <router-link :to="`/companies/${item._user}`" class="mb-4 mb-lg-8">
                        <span> {{ value }} <v-icon size="16">mdi-open-in-new</v-icon> </span>
                    </router-link>
                    <v-btn small outlined width="100" color="grey-d" :to="`/companies/${item._user}`">
                        <span class="grey--text"> 채용공고 </span>
                    </v-btn>
                </v-layout>
            </template>

            <template #[`item.grant`]="{ item }">
                <employers-item-grant
                    v-bind="{
                        value: item,
                        program,
                        isUserHost,
                    }"
                    @input="updateItem"
                />
            </template>

            <template #[`item.match`]="{ item }">
                <employers-item-match
                    v-bind="{
                        program,
                        employer: item,
                        isUserHost,
                        isUserEmployee,
                        isUserEmployer,
                    }"
                />
            </template>

            <template #footer>
                <v-divider />
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" class="my-8" />
            </template>
        </v-data-table>
    </v-sheet>
</template>

<script>
import api from "@/api";
import { mapActions, mapGetters, mapState } from "vuex";
import { initExpoEmployer } from "@/assets/variables/inits";

import EmployersItemGrant from "./employers/employers-item-grant.vue";
import EmployersItemMatch from "./employers/employers-item-match.vue";

export default {
    components: {
        EmployersItemGrant,
        EmployersItemMatch,
    },
    props: {
        isTabActive: { type: Boolean, default: false },
    },
    data: () => ({
        employers: [],
        summary: { totalCount: 0 },

        limit: 10,
        page: 1,

        loading: false,
    }),
    computed: {
        ...mapState("expo", ["program"]),
        ...mapGetters("expo", ["_program", "isUserHost", "isUserEmployee", "isUserEmployer"]),
        ...mapGetters(["doesUserHaveConsoleScope"]),

        headers() {
            let headers = [
                { text: "기업명", value: "info.name", width: 180 },
                { text: "연락처", value: "info.phone", width: 140, cellClass: "word-break-break-all" },
                { text: "이메일", value: "info.email", width: 140, cellClass: "word-break-break-all" },
                { text: "소개", value: "info.desc", cellClass: "text-start white-space-pre-line" },
                { text: "구인내용", value: "info.body", cellClass: "text-start white-space-pre-line" },
            ];

            if (this.isUserHost || this.doesUserHaveConsoleScope) {
                headers.push({ text: "상태", value: "grant", width: 140 });
            }

            if (this.isUserEmployee) {
                headers.push({ text: "면접요청", value: "match", width: 140 });
            }

            return headers.map((item) => ({
                ...item,
                align: item.align ?? "center",
                cellClass: (item.cellClass || "") + " px-10 px-lg-20 py-8 py-lg-16",
            }));
        },
        items() {
            return this.employers.map(initExpoEmployer);
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
    },
    methods: {
        ...mapActions("expo", ["getMatchings"]),
        ...mapActions("expo", { expoInit: "init" }),

        init() {
            if (!this.isTabActive) return;
            this.search();
        },

        async search() {
            this.loading = true;
            try {
                let { _program, skip, limit } = this;
                let { summary, employers } = await api.v1.expo.programs.employers.gets({
                    _program,
                    headers: { skip, limit },
                });
                this.employers = employers;
                this.summary = summary;

                if (this.isUserEmployee) this.getMatchings();
            } finally {
                this.loading = false;
            }
        },

        async update(item) {
            this.loading = true;
            try {
                item._program = this._program;
                let { employer } = await api.v1.expo.programs.employers.put(item);

                this.loading = false;

                employer = initExpoEmployer(employer);
                this.updateItem(employer);
            } finally {
                if (this.loading) this.loading = false;
            }
        },

        updateItem(employer) {
            const index = this.employers.findIndex(({ _id }) => _id == employer._id);
            if (0 <= index) this.employers.splice(index, 1, employer);
            else {
                this.employers = [employer, ...this.employers];
                this.summary.totalCount += 1;
            }
            this.employers = [...this.employers];

            this.search();
            this.expoInit();
        },
    },
    watch: {
        isTabActive() {
            this.search();
        },
        page() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>


<style lang="scss" scoped>
::v-deep .word-break-break-all {
    word-break: break-all;
}
::v-deep .white-space-pre-line {
    white-space: pre-line;
}
</style>